import React from "react";
import "./Dashboard.css";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";


const Dashboard = () => {

  const session = useSelector(state => state.session);

  return (
    <div className="wrapper-div">
      <div className="p-4">
        <h1 className="font-24 font-weigt-s-bold heading-color">Dashboard</h1>
        <p className="font-13 font-weight-normal text-color">
          Welcome Back! {session.user.name}
        </p>  
      </div>
      
    </div>
  );
};

export default Dashboard;
